import axios from 'axios'

//URL base dell'API per i sondaggi, recuperato dall'env file
const SONDAGGIPARTECIPANTE_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'sondaggio-partecipante'

const headers = { 'Content-Type': 'application/json' }

class SondaggioPartecipanteService{


    /**
     * Salva le risposte ad un sondaggio nel sistema.
     * Effettua una richiesta POST a `/sondaggio-partecipante/create` con i dati del sondaggio.
     *
     * @param {Object} sondaggioPartecipante - Oggetto contenente i dettagli delle risposte al sondaggio da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    saveSondaggioPartecipante(sondaggioPartecipante) {
        return axios.post(SONDAGGIPARTECIPANTE_REST_API_URL + "/create", sondaggioPartecipante, headers)
    }

    /**
     * Recupera il sondaggio-partecipante per uno specifico sondaggio e partecipante
     * @param {number} sonId - ID del sondaggio
     * @param {number} parId - ID del partecipante
     * @returns {Promise}
     */
    getBySondaggioAndPartecipante(sonId, parId) {
        return axios.get(`${SONDAGGIPARTECIPANTE_REST_API_URL}/by-sondaggio-partecipante`, {
            params: { sonId, parId },
            headers
        });
    }


    getTotalePartecipantiSondaggio = (sonId) => {
        return axios.get(`${SONDAGGIPARTECIPANTE_REST_API_URL }/${sonId}/partecipanti-rispondenti`);
      };
      
      getPartecipantiEtaBySondaggio = (sonId) => {
        return axios.get(`${SONDAGGIPARTECIPANTE_REST_API_URL }/${sonId}/partecipanti-eta`);

      }

      getHaRisposto = (sonId, parId) => {
        return axios.get(`${SONDAGGIPARTECIPANTE_REST_API_URL }/${sonId}/partecipante/${parId}/ha-risposto`);

      }

      getPunteggiPartecipanti = (sondaggioId) => {
        return axios.get(`${SONDAGGIPARTECIPANTE_REST_API_URL }/${sondaggioId}/punteggi-sondaggio`);
      }



}

// Creazione dell'istanza per essere importata direttamente nei componenti
const sondaggioPartecipanteServiceInstance = new SondaggioPartecipanteService()
export default sondaggioPartecipanteServiceInstance;